export enum UserType {
    Client = 'client',
    Peer = 'peer',
    Founder = 'founder'
}
